<template>
<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ActiveStatusForm
      v-if="activeStatus"
      :activeStatus="activeStatus"
    />

    <LoadingPage v-if="!activeStatus"/>
  </PageRowWrapper>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActiveStatusForm from '@/components/settings/stock-registers/activeStatus/ActiveStatusForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'ActiveStatusEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    ActiveStatusForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      activeStatus: state => state.activestatus.activestatusById
    })
  },
  methods: {
    ...mapActions('activestatus', ['fetchById', 'cleanState'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  },
  destroyed () {
    this.cleanState()
  }
}
</script>